export default __webpack_public_path__ + "static/media/kegstar-logo-only.2c7a4e4f.svg";